import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Avatar, useTheme, useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers";
//import { esES } from '@mui/x-date-pickers/locales';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import "dayjs/locale/es";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Link from "@mui/material/Link";
import HomeIcon from "@mui/icons-material/Home";
import DeleteIcon from "@mui/icons-material/Delete";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Restricted from "components/Restricted";
import clienteAxios from "../../config/clienteAxios";
import {
  useGetProyectoQuery,
  useGetTipoActividadQuery,
  useGetEquiposQuery,
  useGetProfesionesQuery,
} from "state/api";
import { set } from "date-fns";
import axios from "axios";
import { ArrowBack } from "@mui/icons-material";

const CrearActividad = () => {
  // let pro= useGetProyectoQuery();
  // pro=pro.data
  // console.log(pro);
  //  let actividad1= useGetTipoActividadQuery();
  // actividad1=actividad1.data
  //  console.log(actividad1);
  //  let equipos= useGetEquiposQuery();
  // equipos=equipos.data
  //  console.log(equipos);
  //  let roles= useGetProfesionesQuery();
  //  roles=roles.data
  //   console.log(roles);
  const [ejecutar, setEjecutar] = React.useState(true);
  const [pro, setPro] = React.useState([]);
  const [estados, setEstados] = React.useState([]);
  const [municipios, setMunicipios] = React.useState([]);
  const [parroquias, setParroquias] = React.useState([]);
  const [actividad1, setActividad1] = React.useState([]);
  const [equipos, setEquipos] = React.useState([]);
  const [roles, setRoles] = React.useState([]);
  const [projectAccessMessage, setProjectAccessMessage] = React.useState("");
  const [projectAccessBlocked, setProjectAccessBlocked] = React.useState(false);

  const [items, setItems] = React.useState([]);
  const [errors, setErrors] = useState({});

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("token"));
    if (items) {
      setItems(items);
    }
  }, []);

  const rol = items.rol;

  const getTokenHeaders = () => {
    const storedToken = JSON.parse(localStorage.getItem("token") || "{}");
    const idToken = storedToken?.idToken || "";

    return {
      Authorization: idToken ? `Bearer ${idToken}` : "",
      "x-access-token": idToken,
      Accept: "application/json",
    };
  };

  const getPro = async () => {
    try {
      const response = await axios.get("/proyectos/permitidos-crear-convocatoria", {
        headers: getTokenHeaders(),
      });
      const proyectos = Array.isArray(response.data?.proyectos) ? response.data.proyectos : [];

      setPro(proyectos);
      setProjectAccessBlocked(proyectos.length === 0);
      setProjectAccessMessage(
        proyectos.length === 0 ? "No tienes proyectos asignados para crear convocatorias." : ""
      );
      setEjecutar(false);
    } catch (error) {
      const status = error?.response?.status;

      setPro([]);
      setProjectAccessBlocked(true);

      if (status === 401) {
        setProjectAccessMessage("Sesión expirada. Inicia sesión nuevamente.");
        nav("/");
      } else if (status === 403) {
        setProjectAccessMessage("No tienes permiso para crear convocatorias.");
      } else {
        setProjectAccessMessage("No se pudieron cargar los proyectos permitidos para crear convocatorias.");
      }

      setEjecutar(false);
      return;
    }
  };
  const getActividad1 = async () => {
    try {
      const { data1 } = await axios
        .get("/tipoactividad")
        .then(function (response) {
          // setAlerta({})

          setActividad1(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  const getEquipos = async () => {
    try {
      const { data1 } = await axios
        .get("/equipos")
        .then(function (response) {
          // setAlerta({})

          setEquipos(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  const getRoles = async () => {
    try {
      const { data1 } = await axios
        .get("/profesiones")
        .then(function (response) {
          // setAlerta({})

          setRoles(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };

  const getEstados = async () => {
    try {
      const { data1 } = await axios
        .get("/getEstados/")
        .then(function (response) {
          let datos = response.data;
          console.log(response.data, "Estados");
          setEstados(datos);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  const getMunicipios = async () => {
    try {
      const { data1 } = await axios
        .get("/getMunicipios/", {
          params: {
            id: estado,
          },
        })
        .then(function (response) {
          setMunicipios(response.data);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  const getParroquias = async () => {
    try {
      const { data1 } = await axios
        .get("/getParroquias/", {
          params: {
            id: municipio,
          },
        })
        .then(function (response) {
          console.log(response.data, "Parroquias");
          setParroquias(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };

  const [usuarios, setUsuarios] = useState([]);
  const getUsuarios = async () => {
    try {
      const { data2 } = await axios
        .get("/usuariostranscripcion")
        .then(function (response) {
          // setAlerta({})
          console.log(response.data);
          let datos = response.data;
          for (let i = 0; i < datos.length; i++) {
            datos[i].nombreCompleto =
              datos[i].nombres + " " + datos[i].apellidos;
          }
          setUsuarios(datos);
          setEjecutar(false);

          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  const nav = useNavigate();
  //const [actividad2, setActividad2] = React.useState([]);

  //Theme
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");

  ////

  //DatePicker Value
  const [valueDP, setValueDP] = React.useState(null);
  const handleDateChange = (newValue) => {
    setValueDP(newValue);
    if (errors.valueDP) {
      setErrors({ ...errors, valueDP: null });
    }
  };

  //TimePicker Values
  const [newValueHE, setValueHE] = React.useState(null);
  const [newValueHEStr, setValueHEStr] = React.useState(null);
  const handleChangeHE = (newValueHE) => {
    var str = new Date(newValueHE).toString();
    str = str.slice(16, -32);
    console.log(str);
    setValueHEStr(str);
    setValueHE(newValueHE);
    if (errors.newValueHE) {
      setErrors({ ...errors, newValueHE: null });
    }
  };

  const [newValueHS, setValueHS] = React.useState(null);
  const [newValueHSStr, setValueHSStr] = React.useState(null);
  const handleChangeHS = (newValueHS) => {
    var str1 = new Date(newValueHS).toString();
    str1 = str1.slice(16, -32);
    setValueHSStr(str1);
    setValueHS(newValueHS);
    if (errors.newValueHS) {
      setErrors({ ...errors, newValueHS: null });
    }
  };

  const [newValueRT, setValueRT] = React.useState(null);
  const [newValueRTStr, setValueRTStr] = React.useState(null);
  const handleChangeRT = (newValueRT) => {
    var str2 = new Date(newValueRT).toString();
    str2 = str2.slice(16, -32);
    setValueRTStr(str2);
    setValueRT(newValueRT);
    if (errors.newValueRT) {
      setErrors({ ...errors, newValueRT: null });
    }
  };

  //BreadCrumbs
  function handleClickBreadCrumbs(event) {
    event.preventDefault();
  }

  //Modal Styles
  const style = {
    position: "inherit",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 375,
    bgcolor: theme.palette.background.alt,
    border: "2px solid #000",
    borderRadius: 4,
    boxShadow: 1,
    p: 4,
  };

  //Modal Handlers
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openAlert, setOpenAlert] = React.useState(false);
  const handleOpenAlert = () => {
    setOpenAlert(true);
    handleCloseAlert();
  };
  const handleCloseAlert = () =>
    setTimeout(() => {
      setOpenAlert(false);
      nav("/voluntariado");
    }, 2000);

  //Autocomplete States
  const [promotor, setPromotor] = useState("");
  const [inputPromotor, setInputPromotor] = useState("");
  const [volEspecifico, setVolEspecifico] = useState([]);
  const [inputEspecifico, setInputEspecifico] = useState("");

  //Actividad Select
  const [actividadOpc, setActividadOpc] = React.useState([]);
  const handleChangeActividad = (event) => {
    const {
      target: { value },
    } = event;
    setActividadOpc(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
    if (errors.actividadOpc) {
      setErrors({ ...errors, actividadOpc: null });
    }
  };

  //Equipos Select
  const [equiposOpc, setEquiposOpc] = React.useState([]);
  const [equiposQuery, setEquiposQuery] = React.useState([]);
  const handleChangeEquipos = (event) => {
    const {
      target: { value },
    } = event;
    setEquiposOpc(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
    setEquiposQuery(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
    if (errors.equiposOpc) {
      setErrors({ ...errors, equiposOpc: null });
    }
  };

  //Proyecto Select
  const [proyecto, setProyecto] = React.useState("");
  const handleChangeProyecto = (event) => {
    setProyecto(event.target.value);
    if (errors.proyecto) {
      setErrors({ ...errors, proyecto: null });
    }
  };

  //Cantidad de Voluntarios Inputs
  const [data, setData] = useState([{ roles: "", cantidad: "" }]);
  const [data2, setData2] = useState([{ cantidad: "" }]);
  const [activar, setActivar] = useState(true);
  let contador = 0;

  const handleClick = () => {
    setData([...data, { roles: "", cantidad: "" }]);
    setActivar(true);
  };
  const handleChangeInput = (e, i) => {
    const { name, value } = e.target;
    const onchangeVal = [...data];
    onchangeVal[i][name] = value;
    setData(onchangeVal);
    if (errors.rolesData) {
      setErrors({ ...errors, rolesData: null });
    }

    for (let i = 0; i < data.length; i++) {
      if (data[i].roles !== "" && data[i].cantidad !== "") {
        console.log(data[i].cantidad);
      } else {
        contador = contador + 1;
      }
      if (contador !== 0) {
        setActivar(true);
      } else {
        setActivar(false);
      }
    }
  };
  const handleDelete = (i) => {
    const deleteVal = [...data];
    deleteVal.splice(i, 1);
    setData(deleteVal);
  };

  //Socio Radio
  /*const [socioRadio, setSocioRadio] = React.useState("");
  const handleSocioRadio = (event) => {
    setSocioRadio(event.target.value);
  };
  const resetSocioRadio = (event) => {
    setSocioRadio("");
  };*/

  //Refrigerio State
  const [refrigerio, setRefrigerio] = React.useState("");
  const handleRefrigerio = (event) => {
    setRefrigerio(event.target.value);
    if (errors.refrigerio) {
      setErrors({ ...errors, refrigerio: null });
    }
  };

  //Convocar State
  const [convocarOpciones, setConvocarOpciones] = React.useState({
    equipo: false,
    especifico: false,
    roles: false,
  });

  const handleConvocarChange = (event) => {
    setConvocarOpciones({
      ...convocarOpciones,
      [event.target.name]: event.target.checked,
    });
  };

  const handleResetConvocatoria = () => {
    setConvocarOpciones({
      equipo: false,
      especifico: false,
      roles: false,
    });
    setEquiposOpc([]);
    setEquiposQuery([]);
    setVolEspecifico([]);
    setInputEspecifico("");
    setData([{ roles: "", cantidad: "" }]);
    setValueExtra("No");
    setCantidadExtra("");
  };

  const isConvocatoriaSelected =
    convocarOpciones.equipo ||
    convocarOpciones.especifico ||
    convocarOpciones.roles;

  //Voluntarios Extra Radio
  const [valueExtra, setValueExtra] = React.useState("No");
  const handleChangeExtra = (event) => {
    setValueExtra(event.target.value);
  };

  //Cantidad de Voluntarios Extra State
  const [cantidadExtra, setCantidadExtra] = React.useState("");
  const handleCantidadExtra = (event) => {
    setCantidadExtra(event.target.value);
  };

  useEffect(() => {
    if (!isConvocatoriaSelected) {
      setValueExtra("No");
    }
  }, [convocarOpciones, valueExtra]);

  //Voluntarios Extra Inputs
  const [dataExtra, setDataExtra] = useState([{ rolesExtra: "" }]);
  const [dataExtra2, setDataExtra2] = useState([{ cantidadExtra: "" }]);
  const [activarExtra, setActivarExtra] = useState(true);
  let contadorExtra = 0;

  const handleClickExtra = () => {
    setDataExtra([...dataExtra, { rolesExtra: "", cantidadExtra: "" }]);
    setActivarExtra(true);
  };
  const handleChangeInputExtra = (e, i) => {
    const { name, value } = e.target;
    const onchangeValExtra = [...dataExtra];
    onchangeValExtra[i][name] = value;
    setDataExtra(onchangeValExtra);

    for (let i = 0; i < dataExtra.length; i++) {
      if (
        dataExtra[i].rolesExtra !== "" &&
        dataExtra[i].cantidadExtra !== ""
      ) {
        console.log(dataExtra[i].cantidadExtra);
      } else {
        contadorExtra = contadorExtra + 1;
      }
      if (contadorExtra !== 0) {
        setActivarExtra(true);
      } else {
        setActivarExtra(false);
      }
    }
  };
  const handleDeleteExtra = (i) => {
    const deleteValExtra = [...dataExtra];
    deleteValExtra.splice(i, 1);
    setDataExtra(deleteValExtra);
  };

  //Routes
  const handleLinkClick = (event, message) => {
    if (message === "cancelar") {
      nav(-1);
    }
  };
  const handleLinkHome = (event, message) => {
    if (message === "home") {
      nav("/inicio");
    }
  };
  const handleLinkVol = (event, message) => {
    if (message === "voluntariado") {
      nav("/voluntariado");
    }
  };

  //Form Submit
  const [loc, setLoc] = React.useState("");
  const [estado, setEstado] = React.useState("");
  const [municipio, setMunicipio] = React.useState("");
  const [parroquia, setParroquia] = React.useState("");
  const [comunidad, setComunidad] = React.useState("");
  const [desc, setDesc] = React.useState("");
  const [latitud, setLatitud] = React.useState("");
  const [longitud, setLongitud] = React.useState("");
  const [puntoEncuentro, setPuntoEncuentro] = React.useState("");
  const [duracion, setDuracion] = React.useState("");
  const [comentarios, setComentarios] = React.useState("");
  const [stateInsumos, setCheck] = React.useState({
    plumpy: false,
    rutf: false,
    desparasitantes: false,
    micronutrientes: false,
    medicamentos: false,
  });
  const [stateLogistica, setCheckLogistica] = React.useState({
    sillas: false,
    mesas: false,
    minibus: false,
    pickup: false,
  });
  const handleLoc = (event) => {
    setLoc(event.target.value);
  };
  const handleEstado = (event) => {
    setEstado(event.target.value);
    if (event.target.value == "") {
      setMunicipio("");
      setParroquia("");
    }
    if (errors.estado) {
      setErrors({ ...errors, estado: null });
    }
  };

  const handleMunicipio = (event) => {
    setMunicipio(event.target.value);
    if (errors.municipio) {
      setErrors({ ...errors, municipio: null });
    }
  };
  const handleParroquia = (event) => {
    setParroquia(event.target.value);
    if (errors.parroquia) {
      setErrors({ ...errors, parroquia: null });
    }
  };

  useEffect(() => {
    getMunicipios();
    getParroquias();
  }, [estado, municipio]);

  const handleComunidad = (event) => {
    setComunidad(event.target.value);
    if (errors.comunidad) {
      setErrors({ ...errors, comunidad: null });
    }
  };
  const handleDesc = (event) => {
    setDesc(event.target.value);
    if (errors.desc) {
      setErrors({ ...errors, desc: null });
    }
  };
  const handleLatitud = (event) => {
    setLatitud(event.target.value);
    if (errors.latitud) {
      setErrors({ ...errors, latitud: null });
    }
  };
  const handleLongitud = (event) => {
    setLongitud(event.target.value);
    if (errors.longitud) {
      setErrors({ ...errors, longitud: null });
    }
  };
  const handlePuntoEncuentro = (event) => {
    setPuntoEncuentro(event.target.value);
    if (errors.puntoEncuentro) {
      setErrors({ ...errors, puntoEncuentro: null });
    }
  };
  const handleDuracion = (event) => {
    setDuracion(event.target.value);
    if (errors.duracion) {
      setErrors({ ...errors, duracion: null });
    }
  };
  const handleComentarios = (event) => {
    setComentarios(event.target.value);
  };

  const handleChangeCheck = (event) => {
    setCheck({
      ...stateInsumos,
      [event.target.name]: event.target.checked,
    });
  };
  const handleChangeCheckLogistica = (event) => {
    setCheckLogistica({
      ...stateLogistica,
      [event.target.name]: event.target.checked,
    });
  };

  const { plumpy, rutf, desparasitantes, micronutrientes, medicamentos } =
    stateInsumos;
  const { sillas, mesas, minibus, pickup } = stateLogistica;

  const normalizeVenezuelaCoordinates = (latValue, lngValue) => {
    const lat = Number(latValue);
    const lng = Number(lngValue);
    const isValid = (a, b) => a >= 0 && a <= 13 && b >= -74 && b <= -59;
    const isSwapped = (a, b) => a >= -74 && a <= -59 && b >= 0 && b <= 13;

    if (Number.isFinite(lat) && Number.isFinite(lng)) {
      if (isValid(lat, lng)) return { latitud: String(lat), longitud: String(lng) };
      if (isSwapped(lat, lng)) return { latitud: String(lng), longitud: String(lat) };
    }

    return { latitud: latValue, longitud: lngValue };
  };

  const hasValidVenezuelaCoordinates = (latValue, lngValue) => {
    const lat = Number(latValue);
    const lng = Number(lngValue);

    return Number.isFinite(lat) && Number.isFinite(lng) && lat >= 0 && lat <= 13 && lng >= -74 && lng <= -59;
  };

  const normalizeVolunteerRows = (rows = []) =>
    rows
      .filter((item) => String(item.roles || "").trim() && String(item.cantidad || "").trim())
      .map((item) => ({
        roles: item.roles,
        cantidad: item.cantidad,
      }));

  const normalizeIdArray = (values = []) =>
    (Array.isArray(values) ? values : [])
      .map((value) => {
        if (value && typeof value === "object") return value.id ?? value.value ?? "";
        return value;
      })
      .filter((value) => value !== "" && value !== null && value !== undefined);

  const normalizeSpecificVolunteers = (items = []) => {
    if (!Array.isArray(items)) return [];

    const normalized = items
      .map((item) => {
        if (!item) return null;

        if (typeof item === "string") {
          return {
            email: item,
            nombre: item,
          };
        }

        if (typeof item === "number") {
          return {
            id: item,
          };
        }

        const id =
          item.id ??
          item.idusuarios ??
          item.idusuario ??
          item.id_usuarios ??
          item.idUsuario ??
          item.id_usuario ??
          item.id_voluntario ??
          item.idVoluntario ??
          item.value ??
          "";

        const email =
          item.email ??
          item.correo ??
          item.usuario ??
          item.mail ??
          item.correo_electronico ??
          item.email_usuario ??
          "";

        const nombre =
          item.nombre ??
          item.nombres ??
          item.nombreCompleto ??
          item.name ??
          item.label ??
          [item.nombres, item.apellidos].filter(Boolean).join(" ") ??
          email ??
          "";

        return {
          id,
          email,
          nombre,
        };
      })
      .filter((item) => {
        if (!item) return false;
        return String(item.id || item.email).trim() !== "";
      });

    const seen = new Set();

    return normalized.filter((item) => {
      const key = String(item.email || item.id).trim().toLowerCase();
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  };

  const validate = () => {
    let tempErrors = {};
    if (!proyecto) tempErrors.proyecto = "Este campo es requerido.";
    if (actividadOpc.length === 0)
      tempErrors.actividadOpc = "Debe seleccionar al menos una actividad.";
    if (!desc.trim()) tempErrors.desc = "Este campo es requerido.";
    if (!estado) tempErrors.estado = "Este campo es requerido.";
    if (!municipio) tempErrors.municipio = "Este campo es requerido.";
    if (!parroquia) tempErrors.parroquia = "Este campo es requerido.";
    if (!comunidad.trim()) tempErrors.comunidad = "Este campo es requerido.";
    if (!latitud.trim()) tempErrors.latitud = "Este campo es requerido.";
    if (!longitud.trim()) tempErrors.longitud = "Este campo es requerido.";
    if (latitud.trim() && longitud.trim()) {
      const normalizedCoords = normalizeVenezuelaCoordinates(latitud, longitud);
      if (!hasValidVenezuelaCoordinates(normalizedCoords.latitud, normalizedCoords.longitud)) {
        tempErrors.latitud = "Coordenadas fuera del rango de Venezuela.";
        tempErrors.longitud = "Coordenadas fuera del rango de Venezuela.";
      }
    }
    if (!promotor) tempErrors.promotor = "Este campo es requerido.";
    if (!valueDP) tempErrors.valueDP = "Este campo es requerido.";
    if (!puntoEncuentro.trim())
      tempErrors.puntoEncuentro = "Este campo es requerido.";
    if (!duracion.trim()) tempErrors.duracion = "Este campo es requerido.";
    if (!newValueHE) tempErrors.newValueHE = "Este campo es requerido.";
    if (!newValueHS) tempErrors.newValueHS = "Este campo es requerido.";
    if (!newValueRT) tempErrors.newValueRT = "Este campo es requerido.";
    if (!refrigerio) tempErrors.refrigerio = "Este campo es requerido.";

    if (convocarOpciones.equipo && equiposOpc.length === 0) {
      tempErrors.equiposOpc = "Debe seleccionar al menos un equipo.";
    }
    if (convocarOpciones.especifico && volEspecifico.length === 0) {
      tempErrors.volEspecifico = "Debe seleccionar al menos un voluntario.";
    }
    if (convocarOpciones.roles) {
      const rolesInvalidos = data.some(
        (item) => !item.roles || !item.cantidad
      );
      if (rolesInvalidos) {
        tempErrors.rolesData = "Debe completar Rol y Cantidad para cada fila.";
      }
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validate()) {
      console.log("Validación fallida. No se puede enviar el formulario.");
      return;
    }

    const cleanedCantidadVoluntarios = normalizeVolunteerRows(data);
    const convocaProfesiones = cleanedCantidadVoluntarios.map((item) => item.roles);
    const cleanedEquipos = normalizeIdArray(equiposOpc);
    const cleanedEquiposQuery = normalizeIdArray(equiposQuery);
    const normalizedCoords = normalizeVenezuelaCoordinates(latitud, longitud);
    console.log("volEspecifico raw antes de normalizar:", volEspecifico);
    const especificosNormalizados = convocarOpciones.especifico
      ? normalizeSpecificVolunteers(volEspecifico)
      : [];
    const payload = {
      //idConvocatoria: params.idConvocatoria,
      idProyecto: proyecto,
      actividad: JSON.stringify(actividadOpc),
      descripcion: desc,
      descripcionConvo: desc,
      estadoConvo: estado,
      municipio: municipio,
      parroquia: parroquia,
      comunidad: comunidad,
      latitud: normalizedCoords.latitud,
      longitud: normalizedCoords.longitud,
      fecha: valueDP,
      puntoEncuentro: puntoEncuentro,
      duracion: duracion,
      horaEncuentro: newValueHEStr,
      horaSalida: newValueHSStr,
      horaRetorno: newValueRTStr,
      cantidadVoluntarios: JSON.stringify(cleanedCantidadVoluntarios),
      equipos: JSON.stringify(cleanedEquipos),
      logistica: JSON.stringify(stateLogistica),
      comentarios: comentarios,
      insumos: JSON.stringify(stateInsumos),
      equiposQuery: cleanedEquiposQuery,
      profesionesQuery: convocaProfesiones,
      especificos: JSON.stringify(especificosNormalizados),
      especificosQuery: especificosNormalizados,
      extra: valueExtra,

      // //        nombres: (dataform.get('nombreProyecto')),
      // //        apellidos: (dataform.get('codigoProyecto')),
      // //        cedula: (dataform.get('descripcion')),
      // //        correo: dataform.get('email'),
      // //        telefono: dataform.get('textmask'),
      // //        //fnacimiento:new Date(selectedDate).toLocaleDateString('es-ES') ,
      // //        ocupacion: dataform.get('ocupacion'),
      // //        direccion: dataform.get('direccion'),
    };

    console.log("Payload crear convocatoria nueva:", payload);
    console.log("Especificos normalizados:", especificosNormalizados);

    try {
      const response = await axios.post("/crearconvocatoriaNueva/", payload);

      console.log("Resultado notificación convocatoria:", response.data?.resultado_notificacion);
    } catch (error) {}

    handleOpenAlert();
  };
  const [promotores, setPromotores] = React.useState([]);
  const [valuePromotor, setValuePromotor] = React.useState(null);

  const getPromotores = async () => {
    try {
      const { data1 } = await axios
        .get("/getPromotores/")
        .then(function (response) {
          let datos = response.data;
          console.log(response.data, "Promotores");
          setPromotores(datos);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };

  if (ejecutar) {
    getActividad1();
    getEquipos();
    getPro();
    getRoles();
    getEstados();
    getUsuarios();
    getPromotores();
  }

  if (!actividad1 || !pro || !equipos || !roles)
    return (
      <Container component="main" maxWidth="xs">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Container>
    );

  return (
    <Box m="1.5rem 1.5rem">
      {rol === "1" ||
      rol === "2" ||
      rol === "6" ||
      rol === "7" ||
      rol === "8" ||
      rol === "9" ||
      rol === "10" ? (
        <>
          <Box
            gridColumn="span 2"
            gridRow="span 1"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            p="1.25rem 1rem"
            flex="1 1 100%"
            borderRadius="0.55rem"
          >
            <CssBaseline />
            <Box
              role="presentation"
              onClick={handleClickBreadCrumbs}
              sx={{ mb: 3 }}
            >
              <Breadcrumbs aria-label="breadcrumb">
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  href="/inicio"
                  onClick={(event) => handleLinkHome(event, "home")}
                >
                  <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                  Inicio
                </Link>
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  href="/voluntariado"
                  onClick={(event) => handleLinkVol(event, "voluntariado")}
                >
                  <VolunteerActivismIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                  Voluntariado
                </Link>
                <Typography
                  sx={{ display: "flex", alignItems: "center" }}
                  color="text.primary"
                >
                  <MoreTimeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                  Crear Convocatoria
                </Typography>
              </Breadcrumbs>
              <Typography variant="h3" sx={{ fontWeight: "bold", mt: 2 }}>
                {" "}
                Crear Convocatoria{" "}
              </Typography>
            </Box>
            <Container>
              <Card
                sx={{
                  borderRadius: 8,
                  boxShadow: 5,
                  bgcolor: theme.palette.background.alt,
                }}
              >
                {/* ///////////////////////////////////  FORMULARIO UNICEF  /////////////////////////////////// */}
                <CardContent>
                  {/*<Grid container spacing={2}>
                    <Grid item>
                      <Avatar
                        sx={{
                          width: isSmallScreen ? 40 : 50,
                          height: isSmallScreen ? 40 : 50,
                          mt: 1,
                          bgcolor: "teal",
                          color: "white",
                          cursor: "pointer",
                          "&:hover": {
                            bgcolor: "lightgrey",
                            color: "gray",
                            boxShadow: 2,
                          },
                        }}
                        onClick={resetSocioRadio}
                      >
                        <ArrowBack sx={{ fontSize: 30 }} />
                      </Avatar>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography
                        className={isSmallScreen ? "text-center" : ""}
                        mt={isSmallScreen ? 1 : 2}
                        mb={2}
                        sx={{ fontSize: isSmallScreen ? 18 : 25 }}
                      >
                        {" "}
                        <b>Convocatoria para UNICEF</b>{" "}
                      </Typography>
                    </Grid>
                  </Grid>*/}
                  <Box>
                    <Divider sx={{ mt: 2, mb: 3 }}>
                      <Chip label="INFORMACIÓN GENERAL" />
                    </Divider>
                    {projectAccessMessage && (
                      <Alert severity={projectAccessBlocked ? "warning" : "info"} sx={{ mb: 2 }}>
                        {projectAccessMessage}
                      </Alert>
                    )}
                    <form onSubmit={handleSubmit} noValidate>
                      <Grid container spacing={2} mt={1}>
                        <Grid item xs={12} sm={4}>
                          <FormControl
                            fullWidth
                            required
                            error={!!errors.proyecto}
                          >
                            <InputLabel id="proyecto-label">
                              Proyecto que Convoca
                            </InputLabel>
                            <Select
                              labelId="proyecto-label"
                              id="convoc"
                              label="Proyecto que Convoca"
                              value={proyecto}
                              onChange={handleChangeProyecto}
                              disabled={projectAccessBlocked}
                            >
                              <MenuItem value="">
                                <em> Seleccione un Proyecto </em>
                              </MenuItem>
                              {pro.map((dat) => {
                                const codigo =
                                  dat.codigo ||
                                  dat.codigoProyecto ||
                                  dat.codigo_proyecto ||
                                  dat.codigo_proyecto_visual ||
                                  "";

                                return (
                                  <MenuItem
                                    key={dat.idproyectos}
                                    value={dat.idproyectos}
                                  >
                                    {codigo ? `${dat.nombre} - ${codigo}` : dat.nombre}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                            {errors.proyecto && (
                              <FormHelperText>
                                {errors.proyecto}
                              </FormHelperText>
                            )}
                            {projectAccessBlocked && projectAccessMessage && (
                              <FormHelperText>{projectAccessMessage}</FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl
                            fullWidth
                            required
                            error={!!errors.actividadOpc}
                          >
                            <InputLabel id="tipo-actividad-label">
                              Tipo de Actividad
                            </InputLabel>
                            <Select
                              labelId="tipo-actividad-label"
                              id="tipoAct"
                              label="Tipo de Actividad"
                              multiple
                              value={actividadOpc}
                              onChange={handleChangeActividad}
                              input={
                                <OutlinedInput label="Tipo de Actividad" />
                              }
                            >
                              {actividad1.map((dat, index) => (
                                <MenuItem key={dat.nombre} value={dat.nombre}>
                                  {dat.nombre}
                                </MenuItem>
                              ))}
                            </Select>
                            {errors.actividadOpc && (
                              <FormHelperText>
                                {errors.actividadOpc}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            name="descripcion"
                            required
                            fullWidth
                            id="descripcion"
                            label="Descripción de la Convocatoria"
                            value={desc}
                            onChange={handleDesc}
                            error={!!errors.desc}
                            helperText={errors.desc}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl
                            fullWidth
                            required
                            error={!!errors.estado}
                          >
                            <InputLabel id="estado-label"> Estado </InputLabel>
                            <Select
                              labelId="estado-label"
                              label="Estado"
                              name="estado"
                              value={estado}
                              onChange={handleEstado}
                            >
                              <MenuItem value={""}>
                                <em> Seleccione un Estado... </em>
                              </MenuItem>
                              {estados.map((dat, index) => (
                                <MenuItem
                                  key={dat.idestado}
                                  value={dat.idestado}
                                >
                                  {dat.nombre}
                                </MenuItem>
                              ))}
                            </Select>
                            {errors.estado && (
                              <FormHelperText>{errors.estado}</FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl
                            fullWidth
                            required
                            error={!!errors.municipio}
                          >
                            <InputLabel id="municipio-label">
                              {" "}
                              Municipio{" "}
                            </InputLabel>
                            <Select
                              labelId="municipio-label"
                              label="Municipio"
                              name="municipio"
                              value={municipio}
                              onChange={handleMunicipio}
                              disabled={estado === ""}
                            >
                              <MenuItem value={""}>
                                <em> Seleccione un Municipio... </em>
                              </MenuItem>
                              {municipios.map((dat, index) => (
                                <MenuItem
                                  key={dat.idmunicipios}
                                  value={dat.idmunicipios}
                                >
                                  {dat.nombre}
                                </MenuItem>
                              ))}
                            </Select>
                            {errors.municipio && (
                              <FormHelperText>
                                {errors.municipio}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl
                            fullWidth
                            required
                            error={!!errors.parroquia}
                          >
                            <InputLabel id="parroquia-label">
                              {" "}
                              Parroquia{" "}
                            </InputLabel>
                            <Select
                              labelId="parroquia-label"
                              label="Parroquia"
                              name="parroquia"
                              value={parroquia}
                              onChange={handleParroquia}
                              disabled={municipio === ""}
                            >
                              <MenuItem value={""}>
                                <em> Seleccione una Parroquia... </em>
                              </MenuItem>
                              {parroquias.map((dat, index) => (
                                <MenuItem
                                  key={dat.idparroquias}
                                  value={dat.idparroquias}
                                >
                                  {dat.nombre}
                                </MenuItem>
                              ))}
                            </Select>
                            {errors.parroquia && (
                              <FormHelperText>
                                {errors.parroquia}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            name="comunidad"
                            required
                            fullWidth
                            id="comunidad"
                            label="Comunidad"
                            value={comunidad}
                            onChange={handleComunidad}
                            error={!!errors.comunidad}
                            helperText={errors.comunidad}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            name="latitud"
                            required
                            fullWidth
                            id="latitud"
                            label="Latitud"
                            value={latitud}
                            onChange={handleLatitud}
                            error={!!errors.latitud}
                            helperText={errors.latitud}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            name="longitud"
                            required
                            fullWidth
                            id="longitud"
                            label="Longitud"
                            value={longitud}
                            onChange={handleLongitud}
                            error={!!errors.longitud}
                            helperText={errors.longitud}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Autocomplete
                            value={valuePromotor}
                            disablePortal
                            onChange={(e, newValue) => {
                              setValuePromotor(newValue);
                              setPromotor(newValue ? newValue.id : "");
                              if (errors.promotor) {
                                setErrors({ ...errors, promotor: null });
                              }
                            }}
                            inputValue={inputPromotor}
                            onInputChange={(e, newInputValue) => {
                              setInputPromotor(newInputValue);
                            }}
                            options={promotores}
                            sx={{ width: "100%" }}
                            getOptionLabel={(option) =>
                              option.nombres + " " + option.apellidos
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Promotor Comunitario"
                                required
                                error={!!errors.promotor}
                                helperText={errors.promotor}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale="es"
                          >
                            <DesktopDatePicker
                              label="Fecha"
                              name="fecha"
                              inputFormat="DD/MM/YYYY"
                              value={valueDP}
                              onChange={handleDateChange}
                              disablePast
                              renderInput={(params) => {
                                return (
                                  <TextField
                                    fullWidth
                                    {...params}
                                    required
                                    error={!!errors.valueDP}
                                    helperText={errors.valueDP}
                                  />
                                );
                              }}
                              clearable
                            />
                          </LocalizationProvider>
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip label="LOGÍSTICA" />
                      </Divider>
                      <Grid container spacing={2} mt={1}>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            name="encuentro"
                            required
                            fullWidth
                            id="encuentro"
                            label="Punto de Encuentro"
                            value={puntoEncuentro}
                            onChange={handlePuntoEncuentro}
                            error={!!errors.puntoEncuentro}
                            helperText={errors.puntoEncuentro}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            name="duracion"
                            required
                            fullWidth
                            id="duracion"
                            label="Duración Aproximada"
                            value={duracion}
                            onChange={handleDuracion}
                            error={!!errors.duracion}
                            helperText={errors.duracion}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <MobileTimePicker
                              name="horaEncuentro"
                              label="Hora de Encuentro"
                              value={newValueHE}
                              onChange={handleChangeHE}
                              renderInput={(params) => {
                                return (
                                  <TextField
                                    fullWidth
                                    {...params}
                                    required
                                    error={!!errors.newValueHE}
                                    helperText={errors.newValueHE}
                                  />
                                );
                              }}
                            />
                          </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <MobileTimePicker
                              name="horaSalida"
                              label="Hora de Salida"
                              value={newValueHS}
                              onChange={handleChangeHS}
                              renderInput={(params) => (
                                <TextField
                                  fullWidth
                                  {...params}
                                  required
                                  error={!!errors.newValueHS}
                                  helperText={errors.newValueHS}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <MobileTimePicker
                              name="horaRetorno"
                              label="Hora Estimada de Retorno"
                              value={newValueRT}
                              onChange={handleChangeRT}
                              renderInput={(params) => (
                                <TextField
                                  fullWidth
                                  {...params}
                                  required
                                  error={!!errors.newValueRT}
                                  helperText={errors.newValueRT}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl
                            fullWidth
                            required
                            error={!!errors.refrigerio}
                          >
                            <InputLabel id="refrigerio-label">
                              Refrigerio
                            </InputLabel>
                            <Select
                              labelId="refrigerio-label"
                              value={refrigerio}
                              label="Refrigerio"
                              onChange={handleRefrigerio}
                            >
                              <MenuItem value={"Si"}>Si</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                            </Select>
                            {errors.refrigerio && (
                              <FormHelperText>
                                {errors.refrigerio}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 4, mb: 3 }} />
                      <Grid container spacing={2} justifyContent="center">
                        <Grid item xs={12} sm={6}>
                          <FormControl component="fieldset" variant="standard">
                            <FormLabel
                              component="legend"
                              className="text-center"
                              sx={{
                                mb: 2,
                                fontSize: 16,
                                fontWeight: "bold",
                              }}
                            >
                              ¿Qué se requiere convocar?
                            </FormLabel>
                            <FormGroup
                              row
                              sx={{ justifyContent: "center" }}
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={convocarOpciones.equipo}
                                    onChange={handleConvocarChange}
                                    name="equipo"
                                  />
                                }
                                label="Equipos"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={convocarOpciones.especifico}
                                    onChange={handleConvocarChange}
                                    name="especifico"
                                  />
                                }
                                label="Voluntarios Específicos"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={convocarOpciones.roles}
                                    onChange={handleConvocarChange}
                                    name="roles"
                                  />
                                }
                                label="Voluntarios por Roles"
                              />
                            </FormGroup>
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Divider
                        sx={{ mt: 4, mb: 3 }}
                        hidden={!convocarOpciones.equipo}
                      >
                        <Chip label="EQUIPOS" />
                      </Divider>
                      <Grid
                        container
                        justifyContent="center"
                        hidden={!convocarOpciones.equipo}
                      >
                        <Grid item xs={12} sm={6} sx={{ mt: 2 }}>
                          <FormControl
                            fullWidth
                            error={!!errors.equiposOpc}
                          >
                            <InputLabel id="equipos-label">
                              Equipos
                            </InputLabel>
                            <Select
                              labelId="equipos-label"
                              id="equipos-select"
                              label="Equipos"
                              multiple
                              value={equiposOpc}
                              onChange={handleChangeEquipos}
                              input={<OutlinedInput label="Equipos" />}
                            >
                              {equipos.map((dat, index) => (
                                <MenuItem key={dat.id} value={dat.id}>
                                  {dat.nombre}
                                </MenuItem>
                              ))}
                            </Select>
                            {errors.equiposOpc && (
                              <FormHelperText>
                                {errors.equiposOpc}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>

                      <Divider
                        sx={{ mt: 4, mb: 3 }}
                        hidden={!convocarOpciones.especifico}
                      >
                        <Chip label="VOLUNTARIOS ESPECÍFICOS" />
                      </Divider>
                      <Grid
                        container
                        justifyContent="center"
                        hidden={!convocarOpciones.especifico}
                      >
                        <Grid item xs={12} sm={6} sx={{ mt: 2 }}>
                          <Autocomplete
                            multiple
                            value={volEspecifico}
                            onChange={(event, newValue) => {
                              console.log("Voluntarios específicos seleccionados:", newValue);
                              setVolEspecifico(newValue);
                              if (errors.volEspecifico) {
                                setErrors({ ...errors, volEspecifico: null });
                              }
                            }}
                            inputValue={inputEspecifico}
                            onInputChange={(event, newInputValue) => {
                              setInputEspecifico(newInputValue);
                            }}
                            isOptionEqualToValue={(option, value) =>
                              String(
                                option.id ??
                                  option.idusuarios ??
                                  option.idusuario ??
                                  option.id_usuarios ??
                                  option.email ??
                                  option.correo ??
                                  ""
                              ) ===
                              String(
                                value.id ??
                                  value.idusuarios ??
                                  value.idusuario ??
                                  value.id_usuarios ??
                                  value.email ??
                                  value.correo ??
                                  ""
                              )
                            }
                            disablePortal
                            id="combo-box-demo"
                            options={usuarios}
                            getOptionLabel={(usuario) =>
                              usuario.nombreCompleto ||
                              [usuario.nombres, usuario.apellidos].filter(Boolean).join(" ") ||
                              usuario.email ||
                              usuario.correo ||
                              ""
                            }
                            sx={{ width: "100%" }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Voluntarios"
                                error={!!errors.volEspecifico}
                                helperText={errors.volEspecifico}
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                      <Divider
                        sx={{ mt: 4, mb: 3 }}
                        hidden={!convocarOpciones.roles}
                      >
                        <Chip label="VOLUNTARIOS POR ROLES" />
                      </Divider>
                      <Box hidden={!convocarOpciones.roles}>
                        {data.map((val, i) => (
                          <div key={i}>
                            <Grid
                              container
                              spacing={2}
                              sx={{ mt: 1 }}
                              justifyContent="center"
                            >
                              <Grid item xs={11} sm={5}>
                                <FormControl fullWidth>
                                  <InputLabel id={`roles-label-${i}`}>
                                    {" "}
                                    Roles{" "}
                                  </InputLabel>
                                  <Select
                                    labelId={`roles-label-${i}`}
                                    id={`roles-select-${i}`}
                                    label="Roles"
                                    name="roles"
                                    value={val.roles}
                                    onChange={(e) => handleChangeInput(e, i)}
                                  >
                                    <MenuItem value="">
                                      <em> Seleccione un Rol </em>
                                    </MenuItem>
                                    {roles.map((dat, index) => (
                                      <MenuItem
                                        key={dat.idprofesiones}
                                        value={dat.idprofesiones}
                                      >
                                        {dat.descripcion}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Grid>
                              <Grid item xs={9} sm={4}>
                                <TextField
                                  fullWidth
                                  id={`cantidad-${i}`}
                                  label="Cantidad"
                                  name="cantidad"
                                  value={val.cantidad}
                                  onChange={(e) => handleChangeInput(e, i)}
                                />
                              </Grid>
                              <Grid item xs={2} sm={1}>
                                <Tooltip title="Eliminar">
                                  <IconButton
                                    aria-label="delete"
                                    size="large"
                                    color="error"
                                    onClick={() => handleDelete(i)}
                                    hidden={data.length <= 1}
                                  >
                                    <DeleteIcon fontSize="inherit" />
                                  </IconButton>
                                </Tooltip>
                              </Grid>
                            </Grid>
                          </div>
                        ))}
                        {errors.rolesData && (
                          <Typography
                            color="error"
                            sx={{ textAlign: "center", mt: 2 }}
                          >
                            {errors.rolesData}
                          </Typography>
                        )}
                        <Grid container justifyContent="center">
                          <Grid item xs={6} sm={2} sx={{ mt: 3 }}>
                            <Button
                              disabled={
                                activar && !data.roles && !data.cantidad
                              }
                              variant="contained"
                              sx={{
                                bgcolor: "teal",
                                color: "white",
                                borderRadius: 2,
                              }}
                              fullWidth
                              onClick={handleClick}
                            >
                              {" "}
                              Añadir Más{" "}
                            </Button>
                          </Grid>
                        </Grid>
                        {/*<p>{JSON.stringify(data)}</p>*/}
                      </Box>
                      <Box hidden={!isConvocatoriaSelected} mt={3}>
                        <Grid container spacing={2} justifyContent="center">
                          <Grid item sm={4}>
                            <Button
                              variant="contained"
                              color="secondary"
                              onClick={handleResetConvocatoria}
                              fullWidth
                            >
                              Deshacer la selección
                            </Button>
                          </Grid>
                        </Grid>
                      </Box>
                      <Divider
                        sx={{ mt: 4, mb: 3 }}
                        hidden={!isConvocatoriaSelected}
                      >
                        <Chip label="VOLUNTARIOS EXTRA" />
                      </Divider>
                      <Grid
                        container
                        spacing={2}
                        justifyContent="center"
                        hidden={!isConvocatoriaSelected}
                      >
                        <Grid item xs={12} sm={3}>
                          <FormControl>
                            <FormLabel
                              className="text-center"
                              id="volExtra-label"
                            >
                              ¿Se requieren Voluntarios Extra?
                            </FormLabel>
                            <RadioGroup
                              row
                              name="volExtra"
                              value={valueExtra}
                              onChange={handleChangeExtra}
                              className="text-center"
                              sx={{ justifyContent: "center" }}
                            >
                              <FormControlLabel
                                value="Si"
                                control={<Radio />}
                                label="Si"
                              />
                              <FormControlLabel
                                value="No"
                                control={<Radio />}
                                label="No"
                              />
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        mt={2}
                        justifyContent="center"
                        hidden={!isConvocatoriaSelected || valueExtra !== "Si"}
                      >
                        <Grid item xs={12} sm={4}>
                          <TextField
                            type="number"
                            label="Cantidad"
                            variant="outlined"
                            value={cantidadExtra}
                            onChange={handleCantidadExtra}
                            fullWidth
                          />
                        </Grid>
                      </Grid>
                      <Box mt={5} hidden={!isConvocatoriaSelected}>
                        <Typography variant="h6" className="text-center">
                          <InfoOutlinedIcon />{" "}
                          <strong>"Voluntario Extra"</strong> se refiere a todo
                          aquel voluntario que no pertenece a tu equipo.
                        </Typography>
                      </Box>
                      <Divider sx={{ mt: 5 }}></Divider>
                      <Grid
                        container
                        sx={{ mt: 2 }}
                        spacing={1}
                        justifyContent="center"
                      >
                        <Grid item sm={3} xs={6}>
                          <Button
                            variant="contained"
                            color="error"
                            size="large"
                            fullWidth
                            onClick={handleOpen}
                          >
                            {" "}
                            Cancelar{" "}
                          </Button>
                        </Grid>
                        <Grid item sm={3} xs={6}>
                          <Button
                            variant="contained"
                            type="submit"
                            sx={{ bgcolor: "teal", color: "white" }}
                            size="large"
                            fullWidth
                            disabled={projectAccessBlocked}
                          >
                            {" "}
                            Guardar{" "}
                          </Button>
                        </Grid>
                      </Grid>
                    </form>
                  </Box>
                </CardContent>
              </Card>
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                slotProps={{ backdrop: { style: { opacity: 0.2 } } }}
              >
                <Box sx={style}>
                  <Typography
                    variant="h6"
                    className="text-center"
                    sx={{ mb: 1.5 }}
                  >
                    {" "}
                    ¿Está seguro de cancelar esta operación?{" "}
                  </Typography>
                  <Divider sx={{ mt: 2 }} />
                  <Grid
                    container
                    sx={{ mt: 1 }}
                    spacing={1}
                    justifyContent="flex-end"
                  >
                    <Grid item>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={handleClose}
                      >
                        {" "}
                        No{" "}
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        sx={{ bgcolor: "teal", color: "white" }}
                        onClick={(event) => handleLinkClick(event, "cancelar")}
                      >
                        {" "}
                        Si{" "}
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Modal>

              <Modal
                open={openAlert}
                onClose={handleCloseAlert}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <Typography id="modal-modal-title" className="text-center">
                    <TaskAltOutlinedIcon
                      color="success"
                      sx={{ fontWeight: "bold", mt: 3, fontSize: 80 }}
                    />
                  </Typography>
                  <Typography
                    id="modal-modal-description"
                    className="text-center"
                    sx={{ mt: 2, fontSize: 20, fontWeight: "bold" }}
                  >
                    ¡Convocatoria creada exitosamente!
                  </Typography>
                </Box>
              </Modal>
            </Container>
          </Box>
        </>
      ) : (
        <Restricted />
      )}
    </Box>
  );
};

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
const top100Films = [
  { label: "The Shawshank Redemption", year: 1994 },
  { label: "The Godfather", year: 1972 },
  { label: "The Godfather: Part II", year: 1974 },
  { label: "The Dark Knight", year: 2008 },
  { label: "12 Angry Men", year: 1957 },
  { label: "Schindler's List", year: 1993 },
  { label: "Pulp Fiction", year: 1994 },
  {
    label: "The Lord of the Rings: The Return of the King",
    year: 2003,
  },
  { label: "The Good, the Bad and the Ugly", year: 1966 },
  { label: "Fight Club", year: 1999 },
  {
    label: "The Lord of the Rings: The Fellowship of the Ring",
    year: 2001,
  },
  {
    label: "Star Wars: Episode V - The Empire Strikes Back",
    year: 1980,
  },
  { label: "Forrest Gump", year: 1994 },
  { label: "Inception", year: 2010 },
  {
    label: "The Lord of the Rings: The Two Towers",
    year: 2002,
  },
  { label: "One Flew Over the Cuckoo's Nest", year: 1975 },
  { label: "Goodfellas", year: 1990 },
  { label: "The Matrix", year: 1999 },
  { label: "Seven Samurai", year: 1954 },
  {
    label: "Star Wars: Episode IV - A New Hope",
    year: 1977,
  },
  { label: "City of God", year: 2002 },
  { label: "Se7en", year: 1995 },
  { label: "The Silence of the Lambs", year: 1991 },
  { label: "It's a Wonderful Life", year: 1946 },
  { label: "Life Is Beautiful", year: 1997 },
  { label: "The Usual Suspects", year: 1995 },
  { label: "Léon: The Professional", year: 1994 },
  { label: "Spirited Away", year: 2001 },
  { label: "Saving Private Ryan", year: 1998 },
  { label: "Once Upon a Time in the West", year: 1968 },
  { label: "American History X", year: 1998 },
  { label: "Interstellar", year: 2014 },
  { label: "Casablanca", year: 1942 },
  { label: "City Lights", year: 1931 },
  { label: "Psycho", year: 1960 },
  { label: "The Green Mile", year: 1999 },
  { label: "The Intouchables", year: 2011 },
  { label: "Modern Times", year: 1936 },
  { label: "Raiders of the Lost Ark", year: 1981 },
  { label: "Rear Window", year: 1954 },
  { label: "The Pianist", year: 2002 },
  { label: "The Departed", year: 2006 },
  { label: "Terminator 2: Judgment Day", year: 1991 },
  { label: "Back to the Future", year: 1985 },
  { label: "Whiplash", year: 2014 },
  { label: "Gladiator", year: 2000 },
  { label: "Memento", year: 2000 },
  { label: "The Prestige", year: 2006 },
  { label: "The Lion King", year: 1994 },
  { label: "Apocalypse Now", year: 1979 },
  { label: "Alien", year: 1979 },
  { label: "Sunset Boulevard", year: 1950 },
  {
    label:
      "Dr. Strangelove or: How I Learned to Stop Worrying and Love the Bomb",
    year: 1964,
  },
  { label: "The Great Dictator", year: 1940 },
  { label: "Cinema Paradiso", year: 1988 },
  { label: "The Lives of Others", year: 2006 },
  { label: "Grave of the Fireflies", year: 1988 },
  { label: "Paths of Glory", year: 1957 },
  { label: "Django Unchained", year: 2012 },
  { label: "The Shining", year: 1980 },
  { label: "WALL·E", year: 2008 },
  { label: "American Beauty", year: 1999 },
  { label: "The Dark Knight Rises", year: 2012 },
  { label: "Princess Mononoke", year: 1997 },
  { label: "Aliens", year: 1986 },
  { label: "Oldboy", year: 2003 },
  { label: "Once Upon a Time in America", year: 1984 },
  { label: "Witness for the Prosecution", year: 1957 },
  { label: "Das Boot", year: 1981 },
  { label: "Citizen Kane", year: 1941 },
  { label: "North by Northwest", year: 1959 },
  { label: "Vertigo", year: 1958 },
  {
    label: "Star Wars: Episode VI - Return of the Jedi",
    year: 1983,
  },
  { label: "Reservoir Dogs", year: 1992 },
  { label: "Braveheart", year: 1995 },
  { label: "M", year: 1931 },
  { label: "Requiem for a Dream", year: 2000 },
  { label: "Amélie", year: 2001 },
  { label: "A Clockwork Orange", year: 1971 },
  { label: "Like Stars on Earth", year: 2007 },
  { label: "Taxi Driver", year: 1976 },
  { label: "Lawrence of Arabia", year: 1962 },
  { label: "Double Indemnity", year: 1944 },
  {
    label: "Eternal Sunshine of the Spotless Mind",
    year: 2004,
  },
  { label: "Amadeus", year: 1984 },
  { label: "To Kill a Mockingbird", year: 1962 },
  { label: "Toy Story 3", year: 2010 },
  { label: "Logan", year: 2017 },
  { label: "Full Metal Jacket", year: 1987 },
  { label: "Dangal", year: 2016 },
  { label: "The Sting", year: 1973 },
  { label: "2001: A Space Odyssey", year: 1968 },
  { label: "Singin' in the Rain", year: 1952 },
  { label: "Toy Story", year: 1995 },
  { label: "Bicycle Thieves", year: 1948 },
  { label: "The Kid", year: 1921 },
  { label: "Inglourious Basterds", year: 2009 },
  { label: "Snatch", year: 2000 },
  { label: "3 Idiots", year: 2009 },
  { label: "Monty Python and the Holy Grail", year: 1975 },
];

export default CrearActividad;
